import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Mail, MessageSquare } from 'lucide-react';
import EmailComposerModal from './EmailComposerModal.jsx';
import { openTextComposer } from '../../lib/phoneEvents.js';

const btn = 'inline-flex items-center gap-1.5 rounded-lg border border-civix-border bg-civix-panel px-2.5 py-1.5 text-[11px] font-semibold text-civix-purpleSoft transition hover:border-civix-purple/50 hover:text-white disabled:cursor-not-allowed disabled:opacity-40';

/**
 * Quick communication buttons on the lead profile.
 *   Send Email → composer modal (To / template / subject / message)
 *   Send Text  → opens the Phone Panel on its Send Text tab with this lead's number filled in
 * @param {{lead: object, leadId: string, onChange?: () => void}} props
 */
export default function LeadCommActions({ lead, leadId, onChange }) {
  const [emailOpen, setEmailOpen] = useState(false);
  const name = [lead?.firstName, lead?.lastName].filter(Boolean).join(' ');

  function text() {
    if (!lead?.phone) { toast.error('This lead has no phone number'); return; }
    openTextComposer({ phone: lead.phone, leadId, name });
  }

  return (
    <>
      <div className="flex flex-wrap items-center gap-2" data-testid="lead-comm-actions">
        <button type="button" onClick={() => setEmailOpen(true)} disabled={!lead?.email} title={lead?.email ? `Email ${lead.email}` : 'No email on file — add one with the edit button'} className={btn} data-testid="send-email-btn">
          <Mail className="h-3.5 w-3.5" /> Send Email
        </button>
        <button type="button" onClick={text} disabled={!lead?.phone} title="Open the Phone Panel to text this lead" className={btn} data-testid="send-text-btn">
          <MessageSquare className="h-3.5 w-3.5" /> Send Text
        </button>
      </div>
      {emailOpen && <EmailComposerModal lead={lead} leadId={leadId} onClose={() => setEmailOpen(false)} onSent={onChange} />}
    </>
  );
}
